
import { useSelector } from 'react-redux'
import { BeatLoader } from 'react-spinners'
import { AppState } from '../../redux/types'
type Props = {
    loading : boolean
}
const TransparentLoader = (props: Props) => {
  const siteConfigRootColors = useSelector((state: AppState) => state.siteThemeConfig.colors)
  return (
    <>
      {props.loading ? (
        <div className='flex items-center justify-center z-[2147483647]  h-screen fixed bottom-0 left-0 top-0 right-0 bg-[#32323252]'>
            <BeatLoader className="d-inline" color={siteConfigRootColors.primary_default} loading={props.loading} speedMultiplier={1} size={20} />
        </div>
      ): null}
    </>
  )
}
export default TransparentLoader